import logo from './logo.svg';
import './App.css';
// src/App.js
import React from 'react';
import AppRouter from './AppRouter';
import './App.css';

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
